(function () {
  /* NUR EINMAL AUSFUEHREN (19.08.2026)
     Diese Datei haengt delegierte Listener ans Dokument. Wird sie zweimal
     eingebunden, feuert jeder Klick doppelt — beim In-den-Warenkorb hiesse das
     zwei Positionen statt einer. Bisher band sie nur main-collection ein.
     Inzwischen brauchen sie auch cdx-wishlist, cdx-compare und der
     Tresorfinder, und die koennen auf derselben Seite stehen wie die PLP.
     Der Browser laedt die Datei zwar nur einmal, fuehrt sie aber je
     script-Tag erneut aus. Deshalb der Riegel hier statt an jeder Einbaustelle. */
  if (window.cdxPlpGeladen) return;
  window.cdxPlpGeladen = true;

  var addUrl = (window.routes && window.routes.cartAddUrl) || '/cart/add.js';

  function closestTile(el) { return el.closest('[data-pc-tile]'); }

  /* ---- Schloss-Foto zur aktuell gewaehlten Farbe -------------------------
     Spiegelt die Regel aus snippets/cdx-product-card.liquid, dort im Block
     "Passendes Foto". Sie muss hier stehen und nicht nur dort, weil die Farbe
     erst zur Klickzeit feststeht: serverseitig gilt immer nur EINE.

     1. Kuerzel bis drei Zeichen zaehlen nur zwischen Trennstrichen, laengere
        duerfen frei im Namen stehen. Ohne das trifft "db" in "hades-db-zu"
        genauso wie in "abdeckung".
     2. Der Namensteil VOR dem Kuerzel muss zum aktuellen Hauptbild passen:
        aton-40s-gg-elo-zu ergibt "aton-40s-gg", das Hauptbild
        aton-40s-lg-db-zu ergibt "aton-40s-lg" - verschieden, also raus. So
        bleibt die Farbe erhalten, ohne dass eine Farbtabelle noetig waere;
        der Katalog schreibt die Farbe als Kuerzel (lg, gg, ts), das in keiner
        Optionsliste steht.
     3. Ein Praefix, das nur aus dem Trennstrich besteht, beweist nichts und
        wird verworfen - sonst gewinnt ein allgemeines Werbebild wie
        rfid-usp-1-3.jpg gegen das Produktfoto elios-70-gg-rfid.jpg.
     Die drei Punkte sind dieselben, an denen die Liquid-Fassung am 20.08.2026
     nachgeschaerft wurde; wer einen davon aendert, muss beide Stellen anfassen. */
  function dateiname(url) {
    return String(url).split('/').pop().split('?')[0].toLowerCase().split('.')[0].replace(/_/g, '-');
  }
  /* Tuerzustand aus dem Dateinamen — identisch zur Galerie in cdx-product.js,
     dort steht die ausfuehrliche Begruendung samt Auszaehlung des Katalogs.
     Kurz: zwei Woerter fuer geschlossen (zu, geschlossen), zwei fuer offen
     (offen, halboffen), verglichen wird segmentweise. Der Schloss-Klick will
     die geschlossene Front, dort sitzt das Schloss. */
  var ZU_WORTE = ['zu', 'geschlossen'];
  var OFFEN_WORTE = ['offen', 'halboffen'];
  function zustandVon(name) {
    var seg = String(name).split('-');
    for (var i = 0; i < ZU_WORTE.length; i++) if (seg.indexOf(ZU_WORTE[i]) !== -1) return 'zu';
    for (var o = 0; o < OFFEN_WORTE.length; o++) if (seg.indexOf(OFFEN_WORTE[o]) !== -1) return 'offen';
    return '';
  }
  function schlossFoto(medien, tokens, hauptname, wunsch) {
    if (!medien || !medien.length || !tokens || !tokens.length) return null;
    var hauptBnd = '-' + hauptname + '-';
    var ersterTreffer = null;
    for (var i = 0; i < medien.length; i++) {
      var name = medien[i][0], url = medien[i][1];
      var bnd = '-' + name + '-';
      var treffer = null;
      for (var t = 0; t < tokens.length; t++) {
        var tok = tokens[t].trim();
        if (!tok) continue;
        if (tok.length <= 3) {
          var nd = '-' + tok + '-';
          if (bnd.indexOf(nd) !== -1) { treffer = nd; break; }
        } else if (name.indexOf(tok) !== -1) { treffer = tok; break; }
      }
      if (!treffer) continue;
      var cut = bnd.split(treffer)[0];
      if (cut.length <= 1) continue;
      if (hauptBnd.slice(0, cut.length) !== cut) continue;
      /* Der Wunschzustand gewinnt sofort. Sonst den ersten Treffer merken und
         weitersuchen: taucht spaeter ein Foto im Wunschzustand auf, gilt das.
         Ohne Wunsch bleibt es beim ersten Treffer wie bisher. */
      if (wunsch && zustandVon(name) === wunsch) return url;
      if (ersterTreffer === null) ersterTreffer = url;
    }
    return ersterTreffer;
  }
  function medienListe(reihe) {
    if (!reihe) return null;
    if (reihe.__pcMedien) return reihe.__pcMedien;
    try { reihe.__pcMedien = JSON.parse(reihe.getAttribute('data-pc-media') || '[]'); }
    catch (e) { reihe.__pcMedien = []; }
    return reihe.__pcMedien;
  }
  /* Setzt das Foto der Kachel auf das gewaehlte Schloss, ausgehend vom Bild,
     das gerade zu sehen ist. Gibt es zur Kombination kein Foto, bleibt das
     alte stehen - kein Bildwechsel ist besser als ein falscher. */
  function schlossAnwenden(tile, swatch, wunsch) {
    var reihe = swatch && swatch.closest('.pc-tile-swatches--lock');
    var foto = tile && tile.querySelector('.pc-tile-photo:not(.pc-tile-photo--alt)');
    if (!reihe || !foto) return false;
    var tokens = (swatch.getAttribute('data-lock-tokens') || '').split(',');
    var url = schlossFoto(medienListe(reihe), tokens, dateiname(foto.getAttribute('src')), wunsch);
    if (!url) return false;
    foto.removeAttribute('srcset');
    foto.removeAttribute('sizes');
    foto.setAttribute('src', url);
    return true;
  }

  /* ---- Variante aus Farbe UND Schloss (bt, 06.10.2026, Trello FRxkjSxR) ----
     Freigabe Chris 06.10.2026 fuer diesen einen Fehler in einer cdx-Datei.
     Bis hierher stellte jeder Knopf seine eigene, vorberechnete Variante ein:
     der Farbknopf die ERSTE Variante dieser Farbe (meist Doppelbart), der
     Schlossknopf eine Variante mit diesem Schloss. Nach "Zahlenschloss, dann
     Graphitgrau" zeigten Link und Warenkorb deshalb auf Graphitgrau mit
     Doppelbartschloss, und der Preis blieb beim "ab"-Preis stehen.
     Jetzt traegt jede Kachel einmal ihre kaufbaren Varianten als JSON
     (snippets/bt-pc-varianten.liquid, script[data-pc-variants]). Nach jedem
     Klick wird aus gewaehlter Farbe und gewaehltem Schloss genau eine Variante
     aufgeloest, daraus kommen Link, Warenkorb-Variante, Preis ("ab" faellt
     weg), Rabattkennzeichen und Lagerstatus. Schloesser, die es in der
     gewaehlten Farbe nicht gibt, werden ausgegraut (Klasse unavail, CSS in
     bt-section-styles.css) und nehmen keinen Klick an. Ohne Liste (Variantenmodus,
     aeltere Kachel) bleibt alles beim bisherigen Weg ueber data-url,
     data-variant und data-ls. */
  function variantenDaten(tile) {
    if (tile.__pcVar !== undefined) return tile.__pcVar;
    var el = tile.querySelector('script[data-pc-variants]');
    var d = null;
    if (el) {
      try {
        d = {
          list: JSON.parse(el.textContent || '[]'),
          si: parseInt(el.getAttribute('data-si'), 10),
          li: parseInt(el.getAttribute('data-li'), 10)
        };
        if (isNaN(d.si)) d.si = -1;
        if (isNaN(d.li)) d.li = -1;
        if (!d.list || !d.list.length) d = null;
      } catch (err) { d = null; }
    }
    tile.__pcVar = d;
    return d;
  }
  function wert(el) {
    return el ? String(el.getAttribute('title') || '').toLowerCase().trim() : null;
  }
  /* Gewaehlte Farbe: die markierte Farbe der Kachel, auch im Gruppenmodus, wo
     die Farbe nur angezeigt wird. Gewaehltes Schloss: das markierte Schloss. */
  function gewaehlteFarbe(tile) {
    return tile.querySelector('.pc-tile-swatches:not(.pc-tile-swatches--lock) .pc-swatch.selected');
  }
  function gewaehltesSchloss(tile) {
    return tile.querySelector('.pc-tile-swatches--lock [data-pc-swatch].selected');
  }
  function passende(d, farbe, schloss) {
    var out = [];
    for (var i = 0; i < d.list.length; i++) {
      var v = d.list[i], o = v.o || [];
      if (v.a === false) continue;
      if (farbe !== null && d.si >= 0 && String(o[d.si] || '').toLowerCase().trim() !== farbe) continue;
      if (schloss !== null && d.li >= 0 && String(o[d.li] || '').toLowerCase().trim() !== schloss) continue;
      out.push(v);
    }
    return out;
  }
  /* Schlossknoepfe ohne Variante in der gewaehlten Farbe ausgrauen. */
  function schloesserMarkieren(tile, d) {
    if (d.li < 0) return;
    var farbe = wert(gewaehlteFarbe(tile));
    var knoepfe = tile.querySelectorAll('.pc-tile-swatches--lock [data-pc-swatch]');
    for (var i = 0; i < knoepfe.length; i++) {
      var k = knoepfe[i];
      var gibt = passende(d, farbe, wert(k)).length > 0;
      k.classList.toggle('unavail', !gibt);
      if (gibt) k.removeAttribute('aria-disabled');
      else k.setAttribute('aria-disabled', 'true');
    }
  }
  function alleMarkieren(root) {
    var tiles = (root || document).querySelectorAll('[data-pc-tile]');
    for (var i = 0; i < tiles.length; i++) {
      var d = variantenDaten(tiles[i]);
      if (d) schloesserMarkieren(tiles[i], d);
    }
  }
  /* Lagerstatus und Lieferzeit auf die Kachel ziehen (09.09.2026):
     ls = "Text|~|Farbe|~|Lieferzeit" aus cdx-lagerstatus. Nur wenn die Zeile
     aus dem Variantenstatus kommt (data-pc-avail-sync), ein gepflegtes
     Produkt-Metafeld lieferstatus bleibt unangetastet. */
  function lagerstatusSetzen(tile, ls) {
    var avail = tile.querySelector('[data-pc-avail-sync]');
    if (!ls || !avail) return;
    var parts = ls.split('|~|');
    var stock = avail.querySelector('[data-pc-ls-stock]');
    var txt = avail.querySelector('[data-pc-ls-text]');
    var time = avail.querySelector('[data-pc-ls-time]');
    var tone = (parts[1] || '').trim();
    var cls = tone === 'gelb' ? 'pc-delayed' : tone === 'rot' ? 'pc-request' : 'pc-in-stock';
    if (stock) { stock.classList.remove('pc-in-stock', 'pc-delayed', 'pc-request'); stock.classList.add(cls); }
    if (txt) txt.textContent = (parts[0] || '').trim();
    if (time) { var t = (parts[2] || '').trim(); time.textContent = t; time.hidden = !t; }
  }
  /* Rabattkennzeichen der Variante. Einen sichtbaren Streichpreis hat die
     Kachel nur fuer Jungjaeger (.pc-was, siehe varianteAnwenden). */
  function rabattSetzen(tile, v) {
    var lbl = tile.querySelector('.pc-labels .pc-sale');
    if (v.s > 0) {
      if (!lbl) {
        var box = tile.querySelector('.pc-labels');
        if (!box) {
          var bild = tile.querySelector('.pc-tile-img');
          if (!bild) return;
          box = document.createElement('div');
          box.className = 'pc-labels';
          bild.appendChild(box);
        }
        lbl = document.createElement('span');
        lbl.className = 'pc-lbl pc-sale';
        box.appendChild(lbl);
      }
      lbl.textContent = '−' + v.s + ' %';
      lbl.hidden = false;
    } else if (lbl) {
      lbl.hidden = true;
    }
  }
  function varianteAnwenden(tile, v) {
    if (v.url) tile.setAttribute('href', v.url);
    var atc = tile.querySelector('[data-pc-atc]');
    if (atc) { atc.setAttribute('data-variant-id', v.id); atc.removeAttribute('disabled'); }
    var val = tile.querySelector('.pc-tile-price .pc-val');
    if (val && v.p) {
      val.textContent = v.p;
      var ab = tile.querySelector('.pc-tile-price .pc-from');
      if (ab) ab.hidden = true;
    }
    /* Codext 21.10.2026: Jungjaeger-Streichpreis (cdx-product-card rendert .pc-was nur fuer
       Jungjaeger) folgt der Variante, sonst blieb der Preis der Startvariante stehen. */
    var was = tile.querySelector('.pc-tile-price .pc-was');
    if (was) { was.textContent = v.c || ''; was.hidden = !v.c; }
    rabattSetzen(tile, v);
    if (v.ls) lagerstatusSetzen(tile, v.ls);
  }
  /* Kern: Farbe und Schloss lesen, Variante suchen, anwenden. Gibt es das
     gewaehlte Schloss in der Farbe nicht (nur nach einem Farbwechsel moeglich),
     faellt die Kachel auf das guenstigste Schloss dieser Farbe zurueck und
     markiert es. Nie still eine fremde Variante. */
  function varianteAufloesen(tile) {
    var d = variantenDaten(tile);
    if (!d) return false;
    schloesserMarkieren(tile, d);
    var farbe = wert(gewaehlteFarbe(tile));
    var sk = gewaehltesSchloss(tile);
    var schloss = wert(sk);
    var treffer = passende(d, farbe, schloss);
    if (!treffer.length && schloss !== null) {
      var rest = passende(d, farbe, null).slice().sort(function (a, b) { return (a.n || 0) - (b.n || 0); });
      var knoepfe = tile.querySelectorAll('.pc-tile-swatches--lock [data-pc-swatch]');
      for (var r = 0; r < rest.length && !treffer.length; r++) {
        var lw = String((rest[r].o || [])[d.li] || '').toLowerCase().trim();
        for (var k = 0; k < knoepfe.length; k++) {
          if (wert(knoepfe[k]) !== lw) continue;
          for (var j = 0; j < knoepfe.length; j++) knoepfe[j].classList.remove('selected');
          knoepfe[k].classList.add('selected');
          if (schlossAnwenden(tile, knoepfe[k], tile.__pcSchlossGewaehlt ? 'zu' : 'offen')) tile.classList.add('pc-alt-off');
          treffer = [rest[r]];
          break;
        }
      }
    }
    if (treffer.length) varianteAnwenden(tile, treffer[0]);
    return true;
  }

  /* Zusammengefasste Filterwerte (Section-Setting "Filter - Werte
     zusammenfassen"): zu jedem sichtbaren Wert liegen die eingeklappten Werte
     als unsichtbare Checkboxen (.cdx-fmerge) im selben Formular. Beim Klick auf
     den sichtbaren Wert bekommen sie denselben Haken, damit Shopify nach allen
     Werten filtert (mehrere Werte eines Filters = ODER).

     Capture-Phase: theme.js haengt seinen change-Handler per Delegation ans
     Dokument und liest dort sofort das Formular aus — der Abgleich muss vorher
     passieren, sonst geht die erste Auswahl ohne die Unterwerte raus. */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.name || input.name.indexOf('filter.') !== 0) return;
    var form = input.form || (input.closest && input.closest('form'));
    if (!form) return;
    var merges = form.querySelectorAll('.cdx-fmerge');
    for (var i = 0; i < merges.length; i++) {
      var m = merges[i];
      if (m === input) continue;
      if (m.name !== input.name) continue;
      if (m.getAttribute('data-cdx-merge-lead') !== input.value) continue;
      m.checked = input.checked;
    }
  }, true);

  document.addEventListener('click', function (e) {
    var atc = e.target.closest('[data-pc-atc]');
    if (atc) {
      e.preventDefault();
      e.stopPropagation();
      if (atc.hasAttribute('disabled') || atc.classList.contains('is-loading')) return;
      var id = atc.getAttribute('data-variant-id');
      if (!id) return;
      atc.classList.add('is-loading');
      fetch(addUrl, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: id, quantity: 1 })
      }).then(function (r) { return r.json(); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { variant: id, quantity: 1 } }));
          var tile = closestTile(atc);
          if (tile) {
            var price = tile.querySelector('.pc-tile-price');
            if (price) { price.classList.add('pc-price-pulse'); setTimeout(function () { price.classList.remove('pc-price-pulse'); }, 600); }
          }
        })
        .catch(function () {})
        .then(function () { atc.classList.remove('is-loading'); });
      return;
    }

    /* Varianten-Swatch: Kachelbild und Kachel-Link auf die gewaehlte Variante
       umstellen. Die Swatches liegen im Kachel-<a>, deshalb muss der Klick hier
       gestoppt werden, sonst navigiert die Kachel weg. */
    var swatch = e.target.closest('[data-pc-swatch]');
    if (swatch) {
      e.preventDefault();
      e.stopPropagation();
      var swTile = closestTile(swatch);
      if (!swTile) return;
      /* Ausgegrautes Schloss (bt, 06.10.2026): die Kombination mit der
         gewaehlten Farbe gibt es nicht, also nichts umstellen. Auch ohne
         vorherige Markierung pruefen, etwa bei Kacheln aus der Wunschliste. */
      if (swatch.classList.contains('pc-swatch--lock')) {
        var swD = variantenDaten(swTile);
        if (swD && swD.li >= 0 && !passende(swD, wert(gewaehlteFarbe(swTile)), wert(swatch)).length) {
          schloesserMarkieren(swTile, swD);
          return;
        }
      }
      /* Lagerstatus und Lieferzeit der Knopf-Variante (09.09.2026). Mit
         Variantenliste ueberschreibt varianteAufloesen das weiter unten mit
         der Variante aus Farbe UND Schloss. */
      lagerstatusSetzen(swTile, swatch.getAttribute('data-ls'));
      var group = swatch.closest('[data-pc-swatches]');
      if (group) {
        var all = group.querySelectorAll('[data-pc-swatch]');
        for (var i = 0; i < all.length; i++) all[i].classList.remove('selected');
      }
      swatch.classList.add('selected');
      /* Schloss-Klick: das Foto zur GERADE gewaehlten Farbe suchen, nicht das
         serverseitig vorberechnete nehmen. Bis zum 02.09.2026 stand hier das
         Gegenteil - nach einem Farbwechsel bekam die Schloss-Reihe ihr Bild
         entzogen, weil es fuer die alte Farbe galt. Der Kunde klickte dann auf
         ein Schloss und es passierte nichts. Jetzt sucht die Kachel selbst,
         mit derselben Regel wie die Galerie auf der Produktseite.
         Findet sich nichts, faellt sie auf das vorberechnete data-img zurueck. */
      if (swatch.classList.contains('pc-swatch--lock')) {
        /* Ab jetzt hat der Kunde ein Schloss GEWAEHLT. Vorher ist die Markierung
           in der Schloss-Reihe nur eine Voreinstellung des Markups, und die darf
           einen Farbwechsel nicht auf die geschlossene Front ziehen: solange
           niemand ein Schloss angefasst hat, gilt der Farbwunsch, und der zeigt
           den offenen Schrank (Punkt 28). */
        swTile.__pcSchlossGewaehlt = true;
        if (schlossAnwenden(swTile, swatch, 'zu')) {
          var lu = swatch.getAttribute('data-url');
          if (lu) swTile.setAttribute('href', lu);
          var lvid = swatch.getAttribute('data-variant');
          if (lvid) {
            var latc = swTile.querySelector('[data-pc-atc]');
            if (latc) latc.setAttribute('data-variant-id', lvid);
          }
          /* Das Hover-Zweitbild gehoert zur Farbe, nicht zum Schloss. Nach einem
             Schlosswechsel wuerde es ein anderes Schloss zeigen als das Hauptbild,
             deshalb bleibt es hier aus. */
          swTile.classList.add('pc-alt-off');
          varianteAufloesen(swTile);
          return;
        }
      } else {
        /* Farbwechsel: erst das Farbbild setzen (weiter unten), danach das
           gewaehlte Schloss erneut anwenden. Sonst zeigt die Kachel die neue
           Farbe mit dem Schloss der Standardvariante, waehrend in der
           Schloss-Reihe noch etwas anderes angehakt ist. */
        /* Hat der Kunde ein Schloss gewaehlt, bleibt dessen geschlossene Front
           auch in der neuen Farbe stehen. Hat er noch keines angefasst, gilt der
           Farbwunsch: offener Schrank. Das Variantenbild taugt dafuer nicht — es
           ist im Katalog uneinheitlich, beim Aton 40S ist Lichtgrau offen und
           Graphitgrau geschlossen hinterlegt. */
        var reihe = swTile.querySelector('.pc-tile-swatches--lock [data-pc-swatch].selected');
        if (reihe) {
          swTile.__pcSchlossNach = reihe;
          swTile.__pcZustandNach = swTile.__pcSchlossGewaehlt ? 'zu' : 'offen';
        }
      }
      var url = swatch.getAttribute('data-url');
      if (url) swTile.setAttribute('href', url);
      var img = swatch.getAttribute('data-img');
      var photo = swTile.querySelector('.pc-tile-photo:not(.pc-tile-photo--alt)');
      if (img && photo) {
        photo.removeAttribute('srcset');
        photo.removeAttribute('sizes');
        photo.setAttribute('src', img);

        /* Hover-Bild der Variante mitziehen. Gibt es zur Variante kein passendes
           Zweitbild, lieber keins zeigen als das der Standardvariante. */
        var altPhoto = swTile.querySelector('.pc-tile-photo--alt');
        var hover = swatch.getAttribute('data-hover');
        if (altPhoto) {
          if (hover) {
            altPhoto.removeAttribute('srcset');
            altPhoto.removeAttribute('sizes');
            altPhoto.setAttribute('src', hover);
            swTile.classList.remove('pc-alt-off');
          } else {
            swTile.classList.add('pc-alt-off');
          }
        }
      }
      /* Warenkorb-Button mitziehen, sonst landet die zuerst gerenderte Variante im Cart */
      var vid = swatch.getAttribute('data-variant');
      var atcBtn = swTile.querySelector('[data-pc-atc]');
      if (vid && atcBtn) atcBtn.setAttribute('data-variant-id', vid);

      /* Nach dem Farbwechsel das angehakte Schloss wieder anwenden - jetzt
         gegen das neue Farbbild, das oben gerade gesetzt wurde. */
      if (swTile.__pcSchlossNach) {
        var nach = swTile.__pcSchlossNach;
        var wunsch = swTile.__pcZustandNach || 'zu';
        swTile.__pcSchlossNach = null; swTile.__pcZustandNach = null;
        if (schlossAnwenden(swTile, nach, wunsch)) swTile.classList.add('pc-alt-off');
      }
      /* Variante aus Farbe UND Schloss (bt, 06.10.2026), siehe varianteAufloesen. */
      varianteAufloesen(swTile);
      return;
    }

    /* Merken/Vergleichen laufen ueber cdx-lists.js (localStorage + Listen-Seiten). */

    var dBtn = e.target.closest('[data-density] [data-d]');
    if (dBtn) {
      e.preventDefault();
      setDensity(dBtn.getAttribute('data-d'));
      return;
    }

    var sortToggle = e.target.closest('[data-cdx-sort-toggle]');
    if (sortToggle) {
      e.preventDefault();
      var dd = sortToggle.closest('[data-cdx-sortdd]');
      var willOpen = dd && !dd.classList.contains('is-open');
      closeAllSortDD();
      if (willOpen) {
        dd.classList.add('is-open');
        sortToggle.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    var sortOpt = e.target.closest('[data-cdx-sortdd] [data-sort-val]');
    if (sortOpt) {
      e.preventDefault();
      var su = new URL(window.location.href);
      su.searchParams.set('sort_by', sortOpt.getAttribute('data-sort-val'));
      su.searchParams.delete('page');
      window.location.href = su.toString();
      return;
    }

    closeAllSortDD();
  });

  function closeAllSortDD() {
    document.querySelectorAll('[data-cdx-sortdd].is-open').forEach(function (dd) {
      dd.classList.remove('is-open');
      var t = dd.querySelector('[data-cdx-sort-toggle]');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') closeAllSortDD();
  });

  function setDensity(mode) {
    var komfort = mode === 'komfort';
    document.querySelectorAll('[data-cdx-plp-grid]').forEach(function (g) { g.classList.toggle('pc-komfort', komfort); });
    document.querySelectorAll('[data-density]').forEach(function (seg) {
      seg.querySelectorAll('[data-d]').forEach(function (b) { b.classList.toggle('cdx-active', b.getAttribute('data-d') === mode); });
    });
    try { localStorage.setItem('cdx-plp-density', mode); } catch (err) {}
  }

  /* ---------- Nachladen beim Scrollen (Collections mit Varianten-Kacheln) ----------
     Geladen wird die vollstaendige naechste Seite, nicht ?section_id=...: die
     Section-Rendering-API liefert die Section ohne die Einstellungen aus dem
     Template, die Kacheln kaemen also anders konfiguriert zurueck. */

  var moreBusy = false;
  var moreObserver = null;

  function loadMore(box) {
    if (moreBusy || !box) return;
    var link = box.querySelector('[data-cdx-plp-next]');
    var grid = document.querySelector('[data-cdx-plp-grid]');
    if (!link || !grid) return;

    var url = link.getAttribute('href');
    var label = link.textContent;
    moreBusy = true;
    box.classList.add('is-loading');

    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextGrid = doc.querySelector('[data-cdx-plp-grid]');
        if (nextGrid) {
          while (nextGrid.firstElementChild) grid.appendChild(nextGrid.firstElementChild);
        }
        var nextLink = doc.querySelector('[data-cdx-plp-next]');
        if (nextLink) {
          link.setAttribute('href', nextLink.getAttribute('href'));
        } else {
          if (moreObserver) moreObserver.disconnect();
          box.parentNode.removeChild(box);
        }
        /* Zustand von Merken/Vergleichen auf die neuen Kacheln ziehen. */
        if (window.CdxLists && window.CdxLists.sync) window.CdxLists.sync(grid);
        /* Schloesser ohne Variante in der Farbe ausgrauen (bt, 06.10.2026). */
        alleMarkieren(grid);
      })
      .catch(function () {})
      .then(function () {
        moreBusy = false;
        link.textContent = label;
        box.classList.remove('is-loading');
        observeMore();
      });
  }

  function observeMore() {
    var box = document.querySelector('[data-cdx-plp-more]');
    if (moreObserver) { moreObserver.disconnect(); moreObserver = null; }
    if (!box || !('IntersectionObserver' in window)) return;

    moreObserver = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) { loadMore(box); return; }
      }
    }, { rootMargin: '600px 0px' });
    moreObserver.observe(box);
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-cdx-plp-next]');
    if (!link) return;
    e.preventDefault();
    loadMore(link.closest('[data-cdx-plp-more]'));
  });

  /* Nach dem AJAX-Filtern ist der ganze Grid-Block neu im DOM. */
  document.addEventListener('theme:loading:end', function () { moreBusy = false; observeMore(); alleMarkieren(); asideUpdate(); });

  /* Filterspalte mitlaufend sticky (27.10.2026, Ansage Leon). Keine eigene
     Scrollflaeche - die fing am 16.09. das Mausrad ab (siehe cdx-plp.css).
     Stattdessen verschiebt sich die Spalte mit der Seite: passt sie in den
     Viewport, klebt sie unter dem Header. Ist sie hoeher, scrollt sie mit, bis
     ihr Ende sichtbar ist, und beim Hochscrollen sofort wieder zurueck, bis
     ihr Anfang sichtbar ist. So ist jeder Filter mit dem normalen Seiten-
     Scrollen erreichbar, egal in welcher Richtung man gerade unterwegs ist. */
  var asideTop = null, asideLastY = window.pageYOffset;
  function asideUpdate() {
    var card = document.querySelector('.cdx-plp-aside > .card');
    var y = window.pageYOffset;
    if (!card || window.innerWidth < 1000) { asideLastY = y; return; }
    var hd = document.querySelector('.cdx-hd.is-fixed');
    var off = (hd ? Math.max(0, hd.getBoundingClientRect().bottom) : 0) + 16;
    var low = window.innerHeight - card.offsetHeight - 16;
    if (asideTop === null) asideTop = off;
    asideTop = low >= off ? off : Math.min(off, Math.max(low, asideTop - (y - asideLastY)));
    asideLastY = y;
    card.style.top = asideTop + 'px';
  }
  window.addEventListener('scroll', asideUpdate, { passive: true });
  window.addEventListener('resize', asideUpdate);
  /* Auf- und Zuklappen einer Gruppe aendert die Hoehe ohne Scroll-Ereignis. */
  document.addEventListener('click', function (e) {
    if (e.target.closest('.cdx-plp-aside')) setTimeout(asideUpdate, 350);
  });

  function init() {
    asideUpdate();
    var saved;
    try { saved = localStorage.getItem('cdx-plp-density'); } catch (err) {}
    if (saved) setDensity(saved);
    observeMore();
    alleMarkieren();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();